import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import EntrepriseService from '../../services/entrepriseService';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export const DT_entrepriseRerecuteurs = (props) => {

    const [recruteurs, setRecruteurs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const entrepriseService = new EntrepriseService();
    const { t } = useTranslation();
    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        setError(null);

        entrepriseService.getCollaborateursEntreprise(props.entrepriseId)
            .then((data) => {
                setRecruteurs(data);
                setLoading(false);
            })
            .catch((err) => {
                console.error('Erreur lors du chargement des collaborateurs :', err);
                setError(t('error.generic') || 'Une erreur est survenue.');
                setLoading(false);
            });
    }, [props.entrepriseId]);

    const lienPortailEntreprise = (recruteur) => {
        history.push({pathname:'/offers',state:{adminImpersonatingRecruteurId:recruteur.id}});
    }

    const actionBodyTemplateRecruteursPaginated = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-eye" className="p-button-rounded p-button-info p-mr-2" onClick={() => lienPortailEntreprise(rowData)} />
            </React.Fragment>
        );
    }

    const adminTemplate = (rowData) => {
        return (
            <span>{rowData.isAdmin ? t("role.administrator") : t("role.collaborator")}</span>
        );
    }

    return (
        <div className='dte-recruteurs-datatable-container'>
            <h4>{t('entreprise.collaborator.list')}</h4>

            {loading && <p>{t('loading') || 'Chargement en cours...'}</p>}

            {error && <p style={{ color: 'red' }}>{error}</p>}

            {!loading && !error && (
                <DataTable value={recruteurs} paginator rows={10}>
                    <Column field="nom" header={t("general.name")} style={{ width: '15em' }} />
                    <Column field="prenom" header={t("general.firstname")} style={{ width: '15em' }} />
                    <Column field="email" header={t("login.email")} style={{ width: '25em' }} />
                    <Column field="phoneNumber" header={t("general.phone")} style={{ width: '15em' }} />
                    <Column field="isAdmin" header={t("general.status")} body={adminTemplate} style={{ width: '10em' }} />
                    <Column body={actionBodyTemplateRecruteursPaginated} style={{ textAlign: 'center', width: '8em' }} />
                </DataTable>
            )}
        </div>
    );
};